// extracted by mini-css-extract-plugin
export default {"ToolbarButton":"_ToolbarButton--vvXFp","SlateSelection":"_SlateSelection--z3d8K","MarkActive":"_MarkActive--lSn_n"};